<vw-toast-popup
  [isOpen]="isOpen"
  width="100%"
  borderRadius="20px"
  customClass="bg-white"
  (close)="acknowledge()"
>
  <div class="px-4 pb-2">
    <h2 class="pb-1 text-2xl font-semibold text-[#062825]">
      {{ "premium.downgrade.title" | translate }}
    </h2>

    @if (summary) {
      <p class="pb-4 text-sm text-[#6E7B75]">
        {{ "premium.downgrade.locked-structures" | translate }}
      </p>

      <div class="mb-4 flex flex-col gap-2">
        @for (zone of summary.lockedZones; track zone.uid) {
          <div
            class="flex items-center gap-3 rounded-2xl bg-[#F6F8F7] px-3 py-2"
          >
            <span
              class="flex h-7 w-7 items-center justify-center rounded-full bg-white text-[#6E7B75]"
            >
              <vw-lock-icon class="h-4 w-4" />
            </span>
            <span class="text-sm text-[#062825]">{{ zone.name }}</span>
          </div>
        }
        @for (bed of summary.lockedBeds; track bed.uid) {
          <div
            class="flex items-center gap-3 rounded-2xl bg-[#F6F8F7] px-3 py-2"
          >
            <span
              class="flex h-7 w-7 items-center justify-center rounded-full bg-white text-[#6E7B75]"
            >
              <vw-lock-icon class="h-4 w-4" />
            </span>
            <span class="min-w-0 text-sm text-[#062825]">
              {{ bed.name }}
              @if (bed.zoneName) {
                <span class="text-[#9BA6A1]"> · {{ bed.zoneName }}</span>
              }
            </span>
          </div>
        }
      </div>

      <p class="pb-4 text-xs text-[#9BA6A1]">
        {{
          "premium.downgrade.limits"
            | translate
              : { zones: summary.maxZones, beds: summary.maxBedsPerZone }
        }}
      </p>

      <vw-button
        look="primary"
        [label]="'premium.downgrade.cta' | translate"
        customClass="w-full"
        (click)="acknowledge(true)"
      />
      <button
        type="button"
        (click)="acknowledge()"
        class="mt-2 w-full py-2 text-center text-sm text-[#6E7B75]"
      >
        {{ "premium.downgrade.ok" | translate }}
      </button>
    }
  </div>
</vw-toast-popup>
